import { getCurrentInstance } from 'vue';

export const useRouter = () => {
  try {
    const instance = getCurrentInstance();
    return instance?.proxy.$router;
  } catch (error) {
    console.error('No instance', error);
  }
};
